@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Enhanced Modern Header Section - Matching ULB Dashboard -->
<!-- bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50   -->
<div
  class="relative bg-white rounded-md border-b-4 border-blue-200 mb-0 overflow-hidden dshbordhdr cstmmrgin"
>
  <!-- Decorative Background Pattern -->
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"
    ></div>
  </div>

  <div
    class="relative flex items-center justify-between px-2 py-2 flex-wrap gap-2"
  >
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <!-- Icon Badge -->
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        </div>

        <!-- Title Section -->
        <div>
          @if (clntDtls && clntDtls.length > 0) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent mb-0"
            style="font-size: 20px"
          >
            <app-common-header [header_name]="header_label"></app-common-header>
            @if (userDtls?.clap_in==1) {
            <span class="text-blue-600 font-normal text-sm ml-1">Â· CLAP</span>
            }
          </h1>
          }
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <label class="block text-sm font-medium text-gray-700 mr-2"
        >Select Date:</label
      >
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
        class="w-48 rounded-xl shadow-sm"
        style="border-radius: 6px"
      >
      </nz-date-picker>
    </div>
  </div>

  <!-- Bottom Accent Line -->
  <div
    class="absolute bottom-0 left-0 right-0 h-0 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500"
  ></div>
</div>

<!-- SECTION 2: Main Content Wrapper -->
<!-- bg-gray-50 px-2 -->
<div class="py-2 min-h-screen rounded-xl">
  <!-- Row 1: Vehicles Overview, Distance & Working Hours, VMU Maintained, Vehicle Live Status -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
    <!-- Card 1: Vehicles Overview -->
    @for (d of tdyCoveredTrips; track d; let first = $first) { @if (first) {
    <div
      class="bg-white rounded-lg overflow-hidden flex flex-col h-full border border-gray-200"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
      [ngClass]="{ 'ring-2 ring-blue-400': crdOne == true }"
    >
      <!-- Header -->
      <div
        class="bg-slate-600 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
            ></path>
            <path
              d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white"
            >Vehicles Overview</span
          >
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-level-vehicle-dashboard')"
            title="Go to State Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Stats Row -->
        <div class="grid grid-cols-5 gap-1 mb-2">
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ tntLst.length || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">ULB's</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ (d.urban_ttl || 0) + (d.rural_ttl || 0) }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Total</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.own || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Own</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.contract || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Contract</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.sac || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium uppercase">SAC</div>
          </div>
        </div>
        <!-- Primary & Secondary -->
        <div class="grid grid-cols-2 gap-2 flex-1">
          <!-- Primary -->
          <div
            class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex flex-col"
          >
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >Primary</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                d.primary_ttl || 0
              }}</span>
            </div>
            <div class="mb-1.5">
              <div class="flex justify-between mb-0.5">
                <span class="text-xs text-gray-500 font-medium"
                  >Operation %</span
                >
                <span class="text-xs font-semibold text-slate-600"
                  >{{ d.primary_opper || 0 }}%</span
                >
              </div>
              <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                <div
                  class="h-full bg-blue-500 rounded-full"
                  [style.width.%]="d.primary_opper || 0"
                ></div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-1 flex-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ d.primary_operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ d.primary_notoperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-3 gap-0.5 mt-1 pt-1 border-t border-gray-200"
            >
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.own || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">OWN</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.contract || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">CONTRACT</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.sac || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">SAC</div>
              </div>
            </div>
          </div>
          <!-- Secondary -->
          <div
            class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex flex-col"
          >
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >Secondary</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                d.secondary_ttl || 0
              }}</span>
            </div>
            <div class="mb-1.5">
              <div class="flex justify-between mb-0.5">
                <span class="text-xs text-gray-500 font-medium"
                  >Operation %</span
                >
                <span class="text-xs font-semibold text-slate-600"
                  >{{ d.secondary_opper || 0 }}%</span
                >
              </div>
              <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                <div
                  class="h-full bg-blue-500 rounded-full"
                  [style.width.%]="d.secondary_opper || 0"
                ></div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-1 flex-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ d.secondary_operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ d.secondary_notoperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-3 gap-0.5 mt-1 pt-1 border-t border-gray-200"
            >
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.own || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">OWN</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.contract || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">CONTRACT</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.sac || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">SAC</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
    <!-- Card 5: Distance & Working Hours -->
    @for (d of tdyCoveredTrips; track d; let first = $first) { @if (first) {
    <div
      class="bg-white rounded-lg overflow-hidden border border-gray-200 flex flex-col h-full"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
      [ngClass]="{ 'ring-2 ring-blue-400': crdThree == true }"
    >
      <!-- Header -->
      <div
        class="bg-emerald-700 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white"
            >Distance & Working Hours</span
          >
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-level-vehicle-dashboard')"
            title="Go to State Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="hidden">
          <div id="distancePieChart" style="height: 1px; width: 1px"></div>
          <div id="workingHoursPieChart" style="height: 1px; width: 1px"></div>
        </div>
        <div class="grid grid-cols-1 gap-2">
          <!-- Distance -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div
              class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
            >
              <svg
                class="w-3.5 h-3.5 text-slate-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="text-sm font-semibold text-slate-700"
                >Vehicles Travelled</span
              >
            </div>
            @for (dist of ttlDstncCnt; track dist; let firstDist = $first) { @if
            (firstDist) {
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-emerald-600">
                  {{ dist.urbn_tdydst_abv30 || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">>= 500m</div>
                <div class="text-xs font-semibold text-emerald-500">
                  {{
                    ((dist.urbn_tdydst_abv30 || 0) /
                      ((dist.urbn_tdydst_abv30 || 0) +
                        (dist.urbn_tdydst_blw30 || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-red-500">
                  {{ dist.urbn_tdydst_blw30 || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">&lt; 500m</div>
                <div class="text-xs font-semibold text-red-400">
                  {{
                    ((dist.urbn_tdydst_blw30 || 0) /
                      ((dist.urbn_tdydst_abv30 || 0) +
                        (dist.urbn_tdydst_blw30 || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
            </div>
            } }
          </div>
          <!-- Working Hours -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div
              class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
            >
              <svg
                class="w-3.5 h-3.5 text-slate-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="text-sm font-semibold text-slate-700"
                >Working Hours</span
              >
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-emerald-600">
                  {{ d.abv_30_wrkd_tm_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">>= 30 min</div>
                <div class="text-xs font-semibold text-emerald-500">
                  {{
                    ((d.abv_30_wrkd_tm_ct || 0) /
                      ((d.abv_30_wrkd_tm_ct || 0) +
                        (d.blw_30_wrkd_tm_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-red-500">
                  {{ d.blw_30_wrkd_tm_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">&lt; 30 min</div>
                <div class="text-xs font-semibold text-red-400">
                  {{
                    ((d.blw_30_wrkd_tm_ct || 0) /
                      ((d.abv_30_wrkd_tm_ct || 0) +
                        (d.blw_30_wrkd_tm_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="px-2 py-1 border-t border-gray-100">
          <p class="text-xs text-gray-400 mb-0 text-center font-medium">
            Vehicles Travelled > 500m & Working Hours > 30 min = Operated
          </p>
        </div>
      </div>
    </div>
    } }
    <!-- Card 6: VMU Maintained -->
    <div
      class="bg-white rounded-lg overflow-hidden border border-gray-200 flex flex-col h-full"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
    >
      <!-- Header -->
      <div
        class="bg-violet-600 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
          <span class="text-base font-semibold text-white">VMU Maintained</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-level-vehicle-dashboard')"
            title="Go to State Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-2 flex-1">
          <!-- CDMA -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between mb-1.5">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">CDMA</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                vmuMaintainedData.cdma.total || 0
              }}</span>
            </div>
            <div class="flex justify-between items-center mb-0.5">
              <span class="text-xs text-gray-500 font-medium">Operation %</span>
              <span class="text-xs font-semibold text-slate-600"
                >{{ vmuMaintainedData.cdma.operatedPercent || 0 }}%</span
              >
            </div>
            <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden mb-1.5">
              <div
                class="h-full bg-blue-500 rounded-full"
                [style.width.%]="vmuMaintainedData.cdma.operatedPercent || 0"
              ></div>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ vmuMaintainedData.cdma.operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ vmuMaintainedData.cdma.notOperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
          </div>
          <!-- ULB -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between mb-1.5">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">ULB</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                vmuMaintainedData.ulb.total || 0
              }}</span>
            </div>
            <div class="flex justify-between items-center mb-0.5">
              <span class="text-xs text-gray-500 font-medium">Operation %</span>
              <span class="text-xs font-semibold text-slate-600"
                >{{ vmuMaintainedData.ulb.operatedPercent || 0 }}%</span
              >
            </div>
            <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden mb-1.5">
              <div
                class="h-full bg-blue-500 rounded-full"
                [style.width.%]="vmuMaintainedData.ulb.operatedPercent || 0"
              ></div>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ vmuMaintainedData.ulb.operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ vmuMaintainedData.ulb.notOperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 7: Vehicle Live Status -->
    <div
      class="bg-white rounded-lg overflow-hidden border border-gray-200 flex flex-col h-full"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
    >
      <!-- Header -->
      <div
        class="bg-blue-600 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
            />
          </svg>
          <span class="text-base font-semibold text-white"
            >Vehicle Live Status</span
          >
        </div>
        <div class="flex items-center gap-2">
          <div
            class="flex items-center gap-1 bg-emerald-500/30 px-2 py-0.5 rounded"
          >
            <span
              class="w-1.5 h-1.5 bg-emerald-300 rounded-full animate-pulse"
            ></span>
            <span class="text-xs font-medium text-white uppercase">Live</span>
          </div>
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('tracking/list')"
            title="Go to Vehicle Tracking"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Status Row -->
        <div class="grid grid-cols-3 gap-1 mb-1.5">
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-slate-700">
              {{ vehicleLiveStatus.total || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Total</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-emerald-600">
              {{ vehicleLiveStatus.online || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Online</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-red-500">
              {{
                vehicleLiveStatus.offline - vehicleLiveStatus.offline24hr || 0
              }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Offline</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-amber-600">
              {{ vehicleLiveStatus.repair || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Repair</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-gray-600">
              {{ vehicleLiveStatus.others || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Others</div>
          </div>
        </div>
        <!-- Offline > 24 hrs Alert -->
        <div
          class="bg-red-50 rounded-lg p-1.5 border border-red-200 mb-1.5 flex items-center justify-between"
          [ngClass]="{
            'ring-1 ring-red-300': vehicleLiveStatus.offline24hr > 0
          }"
        >
          <div class="flex items-center gap-1.5">
            <svg
              class="w-4 h-4 text-red-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-xs font-semibold text-red-600"
              >Offline > 24 Hrs</span
            >
          </div>
          <span
            class="text-base md:text-lg font-bold text-red-500 bg-white px-2 py-0.5 rounded-md border border-gray-200"
            >{{ vehicleLiveStatus.offline24hr || 0 }}</span
          >
        </div>
        <!-- Activity Grid -->
        <div class="grid grid-cols-3 gap-1">
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-emerald-600">
              {{ vehicleLiveStatus.running || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-emerald-500 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >Running</span
              >
            </div>
          </div>
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-amber-600">
              {{ vehicleLiveStatus.parked || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >Parked</span
              >
            </div>
          </div>
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-gray-600">
              {{ vehicleLiveStatus.onlineStandby24hr || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >24Hr Standby</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Row 2: 4 Cards (Driver Type, Trips, Routes, Fuel Summary) -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3 items-stretch"
  >
    <!-- Card 8: Driver Type -->
    <div
      class="bg-white rounded-lg overflow-hidden border border-gray-200 flex flex-col h-full"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
    >
      <!-- Header -->
      <div
        class="bg-cyan-700 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span class="text-base font-semibold text-white">Driver Type</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >Total: {{ driverTypeCounts.total || 0 }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-level-vehicle-dashboard')"
            title="Go to State Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-1.5 flex-1">
          <!-- OWN -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">OWN</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.own || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.own_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.own_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
          <!-- APCOS -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-slate-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">APCOS</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.apcos || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.apcos_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.apcos_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
          <!-- CONTRACT -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-amber-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >CONTRACT</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.contract || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.contract_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.contract_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 2: TRIPS Card -->
    <div
      class="bg-white rounded-lg overflow-hidden flex flex-col h-full border border-gray-200"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
      [ngClass]="{ 'ring-2 ring-blue-400': crdFour == true }"
    >
      <!-- Header -->
      <div
        class="bg-indigo-600 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white">Trips</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-trips-dashboard')"
            title="Go to Trips & Routes"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Total Summary -->
        <div class="grid grid-cols-2 gap-2 mb-2">
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-emerald-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.trps_asgnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Trips Defined
            </div>
          </div>
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-red-500">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.trps_not_asgnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Trips Not Defined
            </div>
          </div>
        </div>
        <!-- Primary Section -->
        <div
          class="bg-gray-50 rounded-lg p-2 border border-gray-200 mb-1.5 flex-1"
        >
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Primary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_trps_asgnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-red-500">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_trps_not_asgnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
        <!-- Secondary Section -->
        <div class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex-1">
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Secondary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_trps_asgnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-red-500">
                {{
                  (ttlTrpsCnt &&
                    ttlTrpsCnt[0]?.secondary_trps_not_asgnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 3: ROUTES Card -->
    <div
      class="bg-white rounded-lg overflow-hidden flex flex-col h-full border border-gray-200"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
      [ngClass]="{ 'ring-2 ring-blue-400': crdFour == true }"
    >
      <!-- Header -->
      <div
        class="bg-teal-600 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white">Routes</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-trips-dashboard')"
            title="Go to Trips & Routes"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Total Summary -->
        <div class="grid grid-cols-2 gap-2 mb-2">
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-emerald-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.rts_dfnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Routes Defined
            </div>
          </div>
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-amber-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.rts_not_dfnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Routes Not Defined
            </div>
          </div>
        </div>
        <!-- Primary Section -->
        <div
          class="bg-gray-50 rounded-lg p-2 border border-gray-200 mb-1.5 flex-1"
        >
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Primary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_rts_dfnd_vhcls) || 0 }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-amber-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_rts_not_dfnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
        <!-- Secondary Section -->
        <div class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex-1">
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Secondary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_rts_dfnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-amber-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_rts_not_dfnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 4: Fuel Summary -->
    <div
      class="bg-white rounded-lg overflow-hidden flex flex-col h-full border border-gray-200"
      style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)"
    >
      <!-- Header -->
      <div
        class="bg-amber-700 px-3 py-2 flex items-center justify-between rounded-t-lg"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5z"
            />
          </svg>
          <span class="text-base font-semibold text-white">Fuel Summary</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/10 px-2 py-0.5 rounded"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/state-fuel-dashboard')"
            title="Go to State Fuel Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-1.5 flex-1">
          <!-- Current Month -->
          <div
            class="bg-gray-50 rounded-lg border border-gray-200 p-1.5 flex flex-col"
          >
            <div class="text-center mb-1">
              <span class="text-sm font-semibold text-slate-700 uppercase">{{
                currentMonthLabel || "Current"
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1 mb-1">
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ fuelCardData.totalUlbsFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Filled</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ fuelCardData.totalUlbsNotFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Not Filled</div>
              </div>
            </div>
            <div class="flex-1 grid grid-cols-3 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-amber-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.diesel.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Diesel</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-blue-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.petrol.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Petrol</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-emerald-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.cng.kg) }} kg
                </div>
                <div class="text-xs font-medium text-gray-500">CNG</div>
              </div>
            </div>
          </div>
          <!-- Previous Month -->
          <div
            class="bg-gray-50 rounded-lg border border-gray-200 p-1.5 flex flex-col"
          >
            <div class="text-center mb-1">
              <span class="text-sm font-semibold text-slate-700 uppercase">{{
                previousMonthLabel || "Previous"
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1 mb-1">
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ prevMonthFuelData.totalUlbsFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Filled</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ prevMonthFuelData.totalUlbsNotFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Not Filled</div>
              </div>
            </div>
            <div class="flex-1 grid grid-cols-3 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-amber-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.diesel.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Diesel</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-blue-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.petrol.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Petrol</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-emerald-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.cng.kg) }} kg
                </div>
                <div class="text-xs font-medium text-gray-500">CNG</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Mileage Alert -->
        @if (fuelCardData.mileageVarianceCount > 0) {
        <div
          class="mt-1 bg-red-50 rounded-md p-1 border border-red-200 flex items-center justify-between"
        >
          <div class="flex items-center gap-1">
            <svg
              class="w-3 h-3 text-red-400 animate-pulse"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-xs font-semibold text-red-600"
              >Est. Mileage > Actual</span
            >
          </div>
          <span
            class="text-sm md:text-base font-bold text-red-500 bg-white px-1.5 py-0.5 rounded-md border border-gray-200"
            >{{ fuelCardData.mileageVarianceCount }}</span
          >
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- Weekly Charts Section -->
  <div class="mt-3 mb-3">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <!-- Weekly Distance Chart -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-300 p-6">
        <div class="mb-3 pb-2 border-b border-gray-300">
          <h3 class="text-base font-semibold text-gray-800">
            Distance Travelled (Last 7 Days)
          </h3>
        </div>
        <div id="distanceTavelledChart" class="min-h-[350px]"></div>
      </div>

      <!-- Weekly Operational Status Chart -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-300 p-6">
        <div class="mb-3 pb-2 border-b border-gray-300">
          <h3 class="text-base font-semibold text-gray-800">
            Operational Status (Last 7 Days)
          </h3>
        </div>
        <div id="weeklyOperationalStatusChart" class="min-h-[350px]"></div>
      </div>
    </div>
  </div>

  <!-- Fuel Graph and Top 10 Operated ULBs Section -->
  <div class="mt-3 mb-3">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <!-- Fuel Last 7 Days Graph -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-300 p-6">
        <div class="mb-3 pb-2 border-b border-gray-300">
          <h3 class="text-base font-semibold text-gray-800">
            Fuel Consumption (Last 7 Days)
          </h3>
        </div>
        <div id="fuelLast7DaysChart"></div>
      </div>

      <!-- Top 10 / Least 10 Operated ULBs - Toggle Card -->
      @if (top10OperatedUlbs && top10OperatedUlbs.length > 0) {
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-300 overflow-hidden"
      >
        <!-- Header with Toggle -->
        <div
          class="px-4 py-3 border-b border-gray-200"
          [ngClass]="{
            'bg-gradient-to-r from-green-50 to-emerald-50': !isUlbCardFlipped,
            'bg-gradient-to-r from-red-50 to-orange-50': isUlbCardFlipped
          }"
        >
          <div class="flex items-center justify-between">
            <h3
              class="text-base font-semibold flex items-center gap-2"
              [ngClass]="{
                'text-green-800': !isUlbCardFlipped,
                'text-red-800': isUlbCardFlipped
              }"
            >
              @if (!isUlbCardFlipped) {
              <svg
                class="w-5 h-5 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              } @if (isUlbCardFlipped) {
              <svg
                class="w-5 h-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              }
              {{
                isUlbCardFlipped
                  ? "Least 10 Operated ULBs"
                  : "Top 10 Operated ULBs"
              }}
            </h3>
            <!-- Toggle Button Group -->
            <div
              class="inline-flex rounded-lg border border-gray-300 bg-white shadow-sm overflow-hidden"
              role="group"
            >
              <button
                type="button"
                (click)="setUlbCardView('top')"
                [ngClass]="
                  !isUlbCardFlipped
                    ? 'bg-green-500 text-white border-green-500'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                "
                class="px-3 py-1.5 text-xs font-semibold flex items-center gap-1 transition-all duration-200"
              >
                <svg
                  class="w-3.5 h-3.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                Top 10
              </button>
              <button
                type="button"
                (click)="setUlbCardView('least')"
                [ngClass]="
                  isUlbCardFlipped
                    ? 'bg-red-500 text-white border-red-500'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                "
                class="px-3 py-1.5 text-xs font-semibold flex items-center gap-1 transition-all duration-200 border-l border-gray-300"
              >
                <svg
                  class="w-3.5 h-3.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                Least 10
              </button>
            </div>
          </div>
        </div>
        <!-- Content -->
        <div class="p-4">
          <app-data-grid
            style="width: 100%"
            [dataSource]="
              isUlbCardFlipped ? least10OperatedUlbs : top10OperatedUlbs
            "
            [legacyColumns]="top10OperatedUlbsColumnDefs"
            [searchPanel]="false"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="false"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
          >
          </app-data-grid>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- ULB Wise Trips Section -->
  <div class="bg-white rounded-xl shadow-sm border border-gray-300 p-6">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-semibold text-gray-800 mb-0">
        ULB Wise Vehicles
      </h2>
      <!-- View Toggle Button -->
      <div class="flex items-center gap-2">
        <!-- PDF Export (visible only in table view) -->
        @if (currentView === 'table') {
        <button
          type="button"
          (click)="createUlbVehiclesPdf()"
          [disabled]="!ulbTripsDta || !ulbTripsDta.length"
          class="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Download PDF"
        >
          <i nz-icon nzType="file-pdf" nzTheme="outline" class="mr-1"></i>
          PDF
        </button>
        }
        <span class="text-sm text-gray-600">View:</span>
        <div
          class="inline-flex rounded-lg border border-gray-300 bg-white shadow-sm"
          role="group"
        >
          <button
            type="button"
            (click)="toggleView('table')"
            [class]="
              currentView === 'table'
                ? 'px-4 py-2 text-sm font-medium text-white bg-blue-600 border-blue-600 rounded-l-lg'
                : 'px-4 py-2 text-sm font-medium text-gray-700 bg-white border-gray-300 rounded-l-lg hover:bg-gray-50'
            "
          >
            <i nz-icon nzType="table" nzTheme="outline" class="mr-1"></i>
            Table
          </button>
          <button
            type="button"
            (click)="toggleView('map')"
            [class]="
              currentView === 'map'
                ? 'px-4 py-2 text-sm font-medium text-white bg-blue-600 border-blue-600 rounded-r-lg'
                : 'px-4 py-2 text-sm font-medium text-gray-700 bg-white border-gray-300 rounded-r-lg hover:bg-gray-50'
            "
          >
            <i nz-icon nzType="environment" nzTheme="outline" class="mr-1"></i>
            Map
          </button>
        </div>
      </div>
    </div>

    <!-- Table View -->
    @if (currentView === 'table') {
    <div class="relative">
      @if (showLdr) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        [legacyTotalItems]="smryClmns"
        class="p-8"
        style="width: 100%"
        [dataSource]="ulbTripsDta"
        [legacyColumns]="ulbTripscolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ULB Trips Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
        (cellClick)="gotoUlb($event)"
        [cellPrepared]="bound_onCellPrepared"
      >
        <!-- Ignition On/Off Template -->
        <ng-template appGridCell="ignitionTemplate" let-data="cell"
          ><div>
            <span class="text-green-600 font-medium">{{
              data.data.igntn_on_cnt || 0
            }}</span>
            <span class="text-gray-400 mx-1">/</span>
            <span class="text-red-600 font-medium">{{
              data.data.igntn_off_cnt || 0
            }}</span>
          </div></ng-template
        >
        <!--
                    <app-grid-column
                      [showInColumnChooser]="false"
                      [visible]="true"
                      type="buttons"
                      [width]="100"
                      caption="View"
                    cellTemplate="editTemplate"></app-grid-column>
                    <ng-template appGridCell="editTemplate" let-data="cell"><div>
                      <div class="tblEdtBtn" (click)="gotoUlb(data)">
                        <i nz-icon nzType="node-index" nzTheme="outline"></i>
                        <p>Quick View</p>
                      </div>
                    </div></ng-template>
                    -->
      </app-data-grid>
    </div>
    }

    <!-- Map View -->
    @if (currentView === 'map') {
    <div class="map-container-wrapper relative">
      <!-- Map - Full Width/Height -->
      <div
        id="urban-dashboard-map"
        class="urban-map w-full h-full rounded-lg border border-gray-300"
      ></div>
      <!-- Top Stats Row Overlay -->
      @if (selectedUlbData) {
      <div
        class="absolute top-4 left-4 z-10 bg-white rounded-lg shadow-lg border border-gray-200"
        style="max-width: 90vw; padding: 4px; left: 2%"
        class="md:!max-w-[600px] md:!left-[10%]"
      >
        <div class="grid grid-cols-3 md:grid-cols-6 gap-2">
          <div class="text-center">
            <div class="text-lg font-bold text-gray-800">
              {{ selectedUlbData.tot_veh || selectedUlbData.ttl || 0 }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Total Vehicles</div>
          </div>
          <div class="text-center">
            <div class="text-lg font-bold text-green-600">
              {{ selectedUlbData.operated || 0 }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Operated</div>
          </div>
          <div class="text-center">
            <div class="text-lg font-bold text-red-600">
              {{ selectedUlbData.notoperated || 0 }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Not Operated</div>
          </div>
          <div class="text-center">
            <div class="text-lg font-bold text-blue-600">
              {{ selectedUlbData.totl_trps || 0 }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Total Trips</div>
          </div>
          <div class="text-center">
            <div class="text-lg font-bold text-emerald-600">
              {{ selectedUlbData.trvld_trps || 0 }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Travelled</div>
          </div>
          <div class="text-center">
            <div class="text-lg font-bold text-orange-600">
              {{
                (selectedUlbData.totl_trps || 0) -
                  (selectedUlbData.trvld_trps || 0)
              }}
            </div>
            <div class="text-xs text-gray-600 font-medium">Not Travelled</div>
          </div>
        </div>
      </div>
      }
      <!-- ULB List Sidebar Overlay -->
      <div
        class="absolute top-4 right-4 z-10 bg-white rounded-lg shadow-lg border border-gray-200 flex flex-col"
        style="width: 280px; max-width: 90vw; max-height: 600px"
      >
        <div class="p-3 border-b border-gray-200 bg-gray-50">
          <h3 class="text-sm font-semibold text-gray-800 mb-2">ULB List</h3>
          <!-- Search Input -->
          <div class="relative">
            <input
              type="text"
              [(ngModel)]="ulbSearchText"
              (ngModelChange)="filterUlbList()"
              placeholder="Search ULB..."
              class="w-full px-3 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            @if (ulbSearchText) {
            <button
              (click)="clearUlbSearch()"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
            }
          </div>
        </div>
        <div class="flex-1 overflow-y-auto" style="max-height: 520px">
          @for (ulb of filteredUlbList; track ulb; let i = $index) {
          <div
            class="p-2 border-b border-gray-100 cursor-pointer hover:bg-blue-50 transition-colors"
            [class.bg-blue-100]="isUlbSelected(ulb)"
            (click)="selectUlb(ulb, getUlbIndex(ulb))"
          >
            <div class="flex items-center gap-2">
              <div
                class="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
              >
                {{ getUlbIndex(ulb) + 1 }}
              </div>
              <div class="flex-1 min-w-0">
                <div class="font-semibold text-gray-800 text-xs truncate">
                  {{ ulb.tnt_dsply_nm || ulb.tnt_nm }}
                </div>
                <div class="text-xs text-gray-500">
                  Vehicles: {{ ulb.tot_veh || ulb.ttl || 0 }}
                </div>
              </div>
            </div>
          </div>
          } @if (filteredUlbList.length === 0 && ulbTripsDta.length > 0) {
          <div class="p-4 text-center text-xs text-gray-500">No ULB found</div>
          } @if (ulbTripsDta.length === 0) {
          <div class="p-4 text-center text-xs text-gray-500">
            No ULB data available
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
